import { render, staticRenderFns } from "./AuthSignup.vue?vue&type=template&id=1334c077&scoped=true"
import script from "./AuthSignup.vue?vue&type=script&lang=ts"
export * from "./AuthSignup.vue?vue&type=script&lang=ts"
import style0 from "./AuthSignup.vue?vue&type=style&index=0&id=1334c077&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1334c077",
  null
  
)

export default component.exports